"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ValidationManager;

var _NormalValidator = _interopRequireDefault(require("./validators/NormalValidator"));

var _InteractionOnlyValidator = _interopRequireDefault(require("./validators/InteractionOnlyValidator"));

var _MarketoOnlyValidator = _interopRequireDefault(require("./validators/MarketoOnlyValidator"));

var _LeadPreAssignedValidator = _interopRequireDefault(require("./validators/LeadPreAssignedValidator"));

var _UserBypassValidator = _interopRequireDefault(require("./validators/UserBypassValidator"));

var _SystemBypassValidator = _interopRequireDefault(require("./validators/SystemBypassValidator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * ValidationManager dispatches validation to right validation instance depending on
 * ctx_RecordProcessingType value. Dispatching is driven by value of ctx_RecordProcessingType
 * field.
 *
 * Usage:
 * let mgr = new ValidationManager()
 * mgr.validate(records) //will work for single records or list of records
 *
 * Each dispatch instance encapsulates it's own set of unique rules, like what is
 * required, what properties need specific validation handling, etc.
 */
function ValidationManager() {
  var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
  var hvhtCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  /**
   * Mapping of ctx_RecordProcessingType to Validation Instances
   * Exported so we can display schemas on the website
   *
   * E.g.
   * let mgr = new ValidationManager()
   * mgr.validators.Normal.schema() ==> will render schema
   */
  var VALIDATOR_MAP = {
    'Lead-PreAssigned': new _LeadPreAssignedValidator.default(mkto),
    'UserBypass': new _UserBypassValidator.default(mkto, hvhtCheck),
    'SystemBypass': new _SystemBypassValidator.default(mkto, hvhtCheck),
    'InteractionOnly': new _InteractionOnlyValidator.default(mkto),
    'Normal': new _NormalValidator.default(mkto),
    'MarketoOnly': new _MarketoOnlyValidator.default(mkto)
  };

  function validateRecord(record) {
    var recordProcessingType = mkto === "legacy" ? 'ctx_RecordProcessingType' : 'Record_Processing_Type__c';
    var type = record[recordProcessingType];

    if (!type) {
      throw Error("Unable to validate record, missing '".concat(recordProcessingType, "'."));
    }

    if (VALIDATOR_MAP[type]) {
      return _objectSpread({
        type: type
      }, VALIDATOR_MAP[type].validate(record));
    }

    throw Error("Unable to validate record. '".concat(recordProcessingType, "' value is unknown '").concat(type, "'."));
  }

  return {
    validators: VALIDATOR_MAP,
    validate: function validate(rows) {
      if (!Array.isArray(rows)) {
        rows = [rows];
      } // TODO refactor as pure function w/ reduce


      var success = [];
      var failures = {};
      rows.forEach(function (row, i) {
        try {
          var _validateRecord = validateRecord(row),
              result = _validateRecord.result,
              errors = _validateRecord.errors;

          if (errors) {
            addError(failures, {
              row: i,
              errors: errors
            });
          } else {
            success.push(i);
          }
        } catch (e) {
          addError(failures, {
            row: i,
            errors: e.toString()
          });
        }
      });
      return {
        success: success,
        failures: failures
      };

      function addError(failures, _ref) {
        var row = _ref.row,
            errors = _ref.errors;

        if (!failures[row]) {
          if (!Array.isArray(errors)) {
            errors = [errors];
          }

          failures[row] = errors;
        } else {
          failures[row].push(errors);
        }
      } // return rows.reduce((r, row, i) => {
      //
      //     let {result, errors} = validateRecord(row)
      //
      //     // Push results
      //     if (result) {
      //         r.success.push(i)
      //     }
      //     // Create a map or errors,
      //     // row => array or errors for that row
      //     else {
      // 		if (!r.failures[row]) {
      // 			if (!Array.isArray(errors)) {
      // 				errors = [errors]
      // 			}
      // 			r.failures[row] = errors
      // 		} else {
      // 			r.failures[row].push(errors)
      // 		}
      //     }
      //     return r
      //
      // }, {success: [], failure: {}})

    }
  };
}
//# sourceMappingURL=ValidatorManager.js.map